































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "./Loading.vue";
import ShowMoreView from "../controls/ShowMoreView.vue";
import CategoryTypeSelect from "./CategoryTypeSelect.vue";
import SettingsCategoryTypeForm from "../settings/SettingsCategoryTypeForm.vue";

import SettingsJson from "../../shared/SettingsJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType, getCategoryTypeType } from "../../shared/CategoryTypeType";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateItemImageJson, validateItemImageJsonAdd } from "../../shared/ItemImageJson";

export default Vue.extend({
  name: "CategoryTypeInput",
  components: {
    Loading,
    ShowMoreView,
    CategoryTypeSelect,
    SettingsCategoryTypeForm,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    data: Array as PropType<CategoryTypeJson[]>,
    categoryTypeType: String as PropType<CategoryTypeType>,
    label: {
      type: String,
      default: "Kategorien",
    },
    labelIcon: String,
    editable: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      CategoryTypeType: CategoryTypeType,
      details: null as CategoryTypeJson[] | null,
      showAddCategoryType: false as boolean,
      selectedCategoryTypeId: null as number | null,
      addCategoryTypeMode: "read",
      reloadCategoryTypes: new Date() as Date,
      loading: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    /*** START: details view ***/
    toggleAddCategoryType() {
      (this.$refs["showmore-addCategoryType"] as any).toggleExpandable();
      this.showAddCategoryType = !this.showAddCategoryType;
      if (this.showAddCategoryType == false) {
        this.reloadCategoryTypes = new Date();
      }
    },

    openAddCategoryType(item: CategoryTypeJson | null, mode: string) {
      if (item != null) {
        this.selectedCategoryTypeId = item.ID;
      } else {
        this.selectedCategoryTypeId = null;
      }

      this.addCategoryTypeMode = mode;
      this.toggleAddCategoryType();
    },
    /*** END: details view ***/

    init() {
      this.details = this.data;
    },

    //START set cached data

    //END set cached data

    //START set input data (where data be cached)

    //END set input data (where data be cached)
  },

  watch: {
    details: {
      handler() {
        this.$emit("change", this.details);
      },
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    compCategoryTypeType() {
      return getCategoryTypeType(this.categoryTypeType, this.settings.useGeneralCategoryTypes);
    },
  },
});
